import dp from '../../static/dp.jpg'

  export const aboutme = {
    primary: false,
    lightBg: true,
    lightTopLine: false,
    lightText: false,
    lightTextDesc: false,
    topLine: 'Rohaan Joshi',
    headline:
      '"Every Thing Is Very Simple!!!"',
    description:
      "Hello Everyone, Rohaan here. I am a smart working person who loves to make things simpler and faster. I believe in developing user-friendly, secured and efficient things, which can be conveniently and trustfully used by anyone.",
    buttonLabel: 'Know More',
    imgStart: 'start',
    img: dp,
    alt: 'Vault',
    start: 'true'
  }